import { jsxs as s, jsx as c } from "react/jsx-runtime";
import { useTranslation as p } from "../../../../../hooks/useTranslation/index.js";
import { SaveDealAction as e } from "../../../../../types/Deal/index.js";
import { Container as v, NotificationButton as C, SavedDealIcon as b, SaveButton as S } from "./style.js";
import { Bell as h, BellSlash as B, BookmarkSolid as I, Bookmark as u } from "@pelando/fontawesome/icons";
const D = ({
  isInactive: o,
  isSaved: l,
  isNotificationsActived: n,
  commands: r,
  ...m
}) => {
  const { t: a } = p("common"), f = n ? h : B, t = `${a("deal-saved-notification-label")} ${a(n ? "deal-saved-notification-label-actived" : "deal-saved-notification-label-disabled")}`, k = l ? I : u, d = a(l ? "deal-saved-button-label-stop-saving" : "deal-saved-button-label-to-save");
  return /* @__PURE__ */ s(v, { ...m, children: [
    /* @__PURE__ */ s(
      C,
      {
        "aria-label": t,
        "data-inactive": o,
        onClick: () => {
          const i = n ? e.DISABLE_NOTIFICATIONS : e.ENABLE_NOTIFICATIONS;
          r({ type: i });
        },
        children: [
          /* @__PURE__ */ c(
            b,
            {
              icon: f,
              "aria-label": t,
              "aria-disabled": o
            }
          ),
          t
        ]
      }
    ),
    /* @__PURE__ */ c(
      S,
      {
        onClick: () => {
          const i = l ? e.REMOVE : e.SAVE;
          r({ type: i });
        },
        "data-inactive": o,
        "aria-pressed": l,
        "aria-label": d,
        children: /* @__PURE__ */ c(
          b,
          {
            icon: k,
            "aria-label": d,
            "aria-disabled": o
          }
        )
      }
    )
  ] });
};
export {
  D as SaveActions
};
